<template>
    <div class="content">
        <div class="row">
            <div class="col-md-6" >
                <fg-input
                    v-model="task_info.username"
                    type="text"
                    :label="translate('task.username')"
                    :placeholder="translate('task.username')"
                    :readonly="true"
                />
            </div>

            <div class="col-md-6" >
                <fg-input
                    v-model="task_info.status"
                    type="text"
                    :label="translate('task.status')"
                    :placeholder="translate('task.status')"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-md-6" >
                <fg-input
                    v-model="task_info.duration"
                    type="text"
                    :label="translate('task.duration')"
                    :placeholder="translate('task.username')"
                    :readonly="true"
                />
            </div>
            <div class="col-md-6" >
                <fg-input
                    v-model="task_info.device_fid"
                    type="text"
                    :label="translate('task.device_fid')"
                    :placeholder="translate('task.status')"
                    :readonly="true"
                />
            </div>
        </div>

        <div class="row">
            <div class="col-md-6" >
                <fg-input
                    v-model="time"
                    type="text"
                    :label="translate('task.ts')"
                    :placeholder="translate('task.ts')"
                    :readonly="true"
                />
            </div>
            <div class="col-md-6" >
                <fg-input
                    v-model="scheduled"
                    type="text"
                    :label="translate('task.ts_scheduled')"
                    :placeholder="translate('task.ts_scheduled')"
                    :readonly="true"
                />
            </div>
        </div>
    </div>
</template>
<script>


export default {
    name: "MainInfo",
    props: ['task_info'],
    data () {
        return {
            options: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            }
        }
    },

    computed:{
        scheduled(){
            return this.get_date(this.task_info.scheduled_time)
        },
        time(){
            return this.get_date(this.task_info.ts)
        }
    },
    methods: {
        close () {
            this.$emit('close')
        },
    }
}
</script>
<style lang="scss" scoped>
  .content{
      .row{
          margin: 0;
          text-align: left;
          .area{
              margin-bottom: 10px;
          }
      }
  }

</style>
